<lex-doc-viewer-context-panel-template>
  <div context-body>
    <div>
      <div *ngIf="emailThreadingListContext && emailThreadingListContext.docList.length > 0" style="padding: 16px;">
        <lex-flat-button label="Visualize" [icon]="'fa-duotone fa-sunglasses'"
          (click)="navigateToThreading()"></lex-flat-button>
      </div>
      <lex-doc-navigation-list [docListState]="emailThreadingListContext"></lex-doc-navigation-list>
    </div>
  </div>
</lex-doc-viewer-context-panel-template>